import React from 'react';

import { t } from '@sm/intl';

import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { Banner } from '@wds/banner';

import COPY from '~pricing/pages/Enterprise/copy';

export default function HubSpotErrorBanner(): JSX.Element {
  return (
    <Box p={2}>
      <Banner color="error" showIcon>
        <Typography variant="body" component="h4" color="warning" align="left">
          {t(COPY.HUSBPOT_FORM_ERROR)}
        </Typography>
      </Banner>
    </Box>
  );
}
